import React from 'react';
import NavigationModel from '../../../../components/CustomNavigation/NavigationModel';
import dayjs from 'dayjs';

const CroTaskAnalyticsClassroomNavigation = () => {
  const phpNavigationUrl = process.env.REACT_APP_PHP_URL;
  const currentDate =dayjs().format('YYYY-MM-DD');
  const redirectUrl = `${phpNavigationUrl}/analytics/cro_task_analytics_classroom/${currentDate}`;
  return (
    <NavigationModel redirectUrl={redirectUrl} title="CRO Task Analytics - Classroom" navigationTo={'Old Portal'} />
  );
};

export default CroTaskAnalyticsClassroomNavigation;
